<div class="bar" [ngClass]="level">
  <ng-content></ng-content>
</div>
